import { Link, useParams, Navigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { findPost } from "../data/posts";
import { ArrowLeft, Clock } from "lucide-react";

export default function ResourcePost() {
    const { slug } = useParams();
    const post = findPost(slug);
    if (!post) return <Navigate to="/resources" replace />;

    return (
        <div data-testid="resource-post-page" className="bg-[#0A0A0E] text-zinc-100 min-h-screen">
            <Navbar />
            <main className="pt-28 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <Link to="/resources" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-cyan-300 mb-8" data-testid="post-back-link">
                    <ArrowLeft size={14} /> All insights
                </Link>

                <div className="flex items-center gap-3 text-[11px] font-mono-accent uppercase tracking-[0.18em] text-zinc-500 mb-5">
                    <span className="text-cyan-300">{post.category}</span>
                    <span>·</span>
                    <span>{post.date}</span>
                    <span>·</span>
                    <span className="inline-flex items-center gap-1.5">
                        <Clock size={11} /> {post.readMinutes} min read
                    </span>
                </div>

                <h1 className="font-display text-4xl sm:text-5xl text-white leading-[1.05] tracking-tighter">
                    {post.title}
                </h1>

                <div className="my-10 rounded-2xl overflow-hidden border border-white/10">
                    <img src={post.cover} alt={post.title} className="w-full opacity-90" />
                </div>

                <div className="space-y-6 text-zinc-300 leading-relaxed text-base sm:text-lg">
                    {post.body.map((para, i) => (
                        <p key={i} data-testid={`post-paragraph-${i}`}>
                            {para}
                        </p>
                    ))}
                </div>

                <div className="mt-14 card-glow rounded-2xl p-7 flex flex-wrap items-center justify-between gap-5">
                    <div>
                        <div className="eyebrow">Get insights monthly</div>
                        <div className="text-white font-display text-lg mt-2">
                            Join early access — receive the AU freight digest.
                        </div>
                    </div>
                    <Link to="/#early-access" className="btn-primary" data-testid="post-cta">
                        Join early access
                    </Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}
